module.exports = __webpack_public_path__ + "static/media/menu.cd3a6981.svg";